import SEO from '@/components/base/SEO';
import Breadcrumb from '@/components/base/Breadcrumb';

const breadcrumb = [
  { label: 'Accueil', to: '/' },
  { label: 'Mentions légales' },
];

export default function MentionsLegales() {
  return (
    <>
      <SEO
        title="Mentions légales | DFPRO Hérault"
        description="Mentions légales du site DFPRO Hérault. SAS DF PRO, réparation de menuiseries aluminium et PVC dans l'Hérault. SIREN, TVA, coordonnées légales."
        canonicalUrl="https://heraultroulettesbaiesvitrees.fr/mentions-legales/"
      />
      <section className="relative pt-24 pb-12 md:pt-28 md:pb-16 overflow-hidden">
        <img
          src="/images/dfpro-legal-hero.jpg"
          alt="Mentions légales DFPRO Hérault"
          className="absolute inset-0 w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-primary-500/75"></div>
        <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-6">
          <Breadcrumb items={breadcrumb} light />
          <h1 className="text-2xl md:text-3xl font-heading font-bold text-white mt-4">
            Mentions légales
          </h1>
        </div>
      </section>

      <section className="py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <article className="prose prose-lg max-w-none font-body text-foreground-500">
            <h2>Éditeur du site</h2>
            <p>
              Le site internet <strong>heraultroulettesbaiesvitrees.fr</strong> est édité par la société DF PRO, Société par Actions Simplifiée (SAS) au capital social de [CAPITAL] €.
            </p>
            <ul>
              <li><strong>Siège social :</strong> 100 route de Nîmes, 30132 Caissargues, France</li>
              <li><strong>SIREN :</strong> 984 775 262</li>
              <li><strong>SIRET :</strong> 984 775 262 00020</li>
              <li><strong>TVA intracommunautaire :</strong> FR96 984 775 262</li>
              <li><strong>Code APE :</strong> 43.32A — Travaux de menuiserie bois et PVC</li>
              <li><strong>Directeur de la publication :</strong> [PRÉSIDENT]</li>
              <li><strong>Contact :</strong> <a href="mailto:herault@dfpro.fr" className="text-accent-500 hover:underline">herault@dfpro.fr</a> — <a href="tel:+33980802242" className="text-accent-500 hover:underline">09 80 80 22 42</a></li>
            </ul>

            <h2>Hébergement</h2>
            <p>
              Le site <strong>heraultroulettesbaiesvitrees.fr</strong> est hébergé par :
            </p>
            <ul>
              <li><strong>Hébergeur :</strong> Infomaniak Network SA</li>
              <li><strong>Adresse :</strong> 25 rue Eugène-Marziano, 1227 Genève, Suisse</li>
              <li><strong>Site web :</strong> www.infomaniak.com</li>
            </ul>

            <h2>Propriété intellectuelle</h2>
            <p>
              L'ensemble des éléments constituant ce site (textes, graphismes, logo, images, structure) est la propriété exclusive de DF PRO, sauf mentions contraires explicites. Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite sans l'autorisation écrite préalable de DF PRO.
            </p>

            <h2>Responsabilité</h2>
            <p>
              DF PRO s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site, dont elle se réserve le droit de corriger le contenu à tout moment et sans préavis. Toutefois, DF PRO ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition sur ce site. En conséquence, DF PRO décline toute responsabilité pour toute imprécision, inexactitude ou omission portant sur des informations disponibles sur ce site.
            </p>

            <h2>Liens hypertextes</h2>
            <p>
              La mise en place de liens hypertextes pointant vers le site <strong>heraultroulettesbaiesvitrees.fr</strong> est soumise à l'accord préalable de DF PRO. DF PRO ne saurait être tenue responsable du contenu des sites tiers vers lesquels des liens hypertextes pourraient renvoyer depuis son site.
            </p>

            <h2>Droit applicable</h2>
            <p>
              Le site <strong>heraultroulettesbaiesvitrees.fr</strong> et les présentes mentions légales sont soumis au droit français. En cas de litige, et à défaut de résolution amiable, les tribunaux français seront seuls compétents.
            </p>
          </article>
        </div>
      </section>
    </>
  );
}